import React from "react";
import { bool } from "prop-types";
import I18n from "pages/_components/I18n";
import { Link } from "react-router-dom";

const LoginFooter = ({ token, isDesktop }) => (
    <div className="footer-links">
        <div className="help-links">
            <a className="help-link" href="https://ayuda.bibank.com.ar/" target="_blank" rel="noreferrer">
                <I18n componentProps={{ className: "small" }} id="onboarding.moreInformation" />
            </a>
            {token && !isDesktop && (
                <>
                    {" | "}
                    <Link to="/tokenVirtual" style={{ textAlign: "right" }} className="small">
                        <I18n id="onboarding.token" />
                    </Link>
                </>
            )}
        </div>
        <a className="privacy-link" href="https://hb.bibank.com.ar/privacyPolicy" target="_blank" rel="noreferrer">
            <I18n componentProps={{ className: "small" }} id="onboarding.privacypolicy" />
        </a>
    </div>
);

LoginFooter.propTypes = {
    isDesktop: bool.isRequired,
    token: bool,
};

LoginFooter.defaultProps = {
    token: false,
};
export default LoginFooter;
